import React from "react";
import { FormattedMessage } from "react-intl";
import { Badge, Typography } from "antd";
import { getAgeByDate } from "../../../components/util/helpers";
import { useSelector } from "react-redux";

const { Title } = Typography;
const PatientTitle = (props) => {
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const statusData = [
    {
      value: 1,
      name: <FormattedMessage id="app.forms.active" />,
      status: "success",
    },
    {
      value: 2,
      name: <FormattedMessage id="app.forms.not_active" />,
      status: "error",
    },
    {
      value: 3,
      name: <FormattedMessage id="app.forms.candidate" />,
      status: "processing",
    },
    {
      value: 4,
      name: <FormattedMessage id="app.forms.pre" />,
      status: "warning",
    },
  ];

  const status =
    activePatient && activePatient.status_id
      ? statusData[activePatient.status_id - 1]["status"]
      : null;
  const statusName =
    activePatient && activePatient.status_id
      ? statusData[activePatient.status_id - 1]["name"]
      : "";

  const patientAge =
    activePatient && activePatient.birthday
      ? getAgeByDate(activePatient.birthday)
      : null;
  const arr = activePatient.first_name
    ? [`${activePatient.surename} ${activePatient.first_name}`]
    : [];
  if (patientAge) {
    arr.push(patientAge);
  }
  const truncate = (input, num) =>
    input.length > num ? `${input.substring(0, num)}...` : input;
  const name = activePatient ? truncate(arr.join(", "), 24) : "";
  return activePatient ? (
    <div
      style={{
        display: "flex",
        alignItems: "flex-end",
        height: "50px",
        marginTop: "10px",
      }}
    >
      <Title level={1}>{name}</Title>
      <Badge className="status_badge" status={status} text={statusName} />
    </div>
  ) : null;
};

export default PatientTitle;
